import React from "react";
import { company, brands } from "../mock";

const Brands = () => {
  return (
    <section id="marche" className="bg-[#f4f6f9] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-[#0f2846] text-3xl md:text-4xl font-bold">Tutte le marche, un'unica garanzia</h2>
          <div className="w-24 h-1 bg-[#e8464a] mx-auto mt-4 rounded-full" />
          <p className="text-slate-500 mt-5">Lavoriamo motori per oltre 35 marche, dalle italiane alle tedesche, dalle francesi alle giapponesi. Se non vedi la tua marca elencata, contattaci: probabilmente l'abbiamo o possiamo trovarla.</p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-3 md:gap-4 mt-12">
          {brands.map(([code, name], i) => (
            <div key={i} className="bg-white rounded-xl border border-slate-100 p-3 flex flex-col items-center gap-2 hover:shadow-md hover:-translate-y-0.5 transition-all">
              <div className="w-11 h-11 rounded-full border border-slate-200 flex items-center justify-center font-display font-bold text-[#0f2846] text-sm">{code}</div>
              <span className="text-slate-600 text-xs font-medium text-center">{name}</span>
            </div>
          ))}
        </div>
        <p className="text-center text-slate-400 text-xs italic mt-8 max-w-3xl mx-auto">
          I nomi e marchi citati sono di proprietà delle rispettive case automobilistiche. {company.name} non è affiliata o sponsorizzata da nessuna delle case.
        </p>
      </div>
    </section>
  );
};

export default Brands;
